import jwtDecode from 'jwt-decode';
import config from './config';
import { getCookie, clearUserCookies } from './cookies';
import { SessionStorageKeys } from './session-storage';
import { PAGES_BASE_PATHNAMES } from './consts';
import { refreshTokensOkta } from './okta-auth-api';

export const ACCESS_TOKEN_COOKIE = 'ndp-oat';
export const REFRESH_TOKEN_COOKIE = 'ndp-ort';
export const POST_LOGIN_REDIRECT_COOKIE = 'PostLoginRedirect';

export function isTokenExpired(token) {
  if (token) {
    let now = new Date().getTime();
    let decoded;

    try {
      decoded = jwtDecode(token);
    } catch (err) {
      return true;
    }

    //@ts-ignore
    return decoded.exp * 1000 - now < 3000;
  }
  return true;
}

export async function getAccessToken() {
  const accessToken = getCookie(ACCESS_TOKEN_COOKIE);
  if (!accessToken) {
    return undefined;
  }
  if (!isTokenExpired(accessToken)) {
    return accessToken;
  } else {
    try {
      const credentials = await refreshTokensOkta(getCookie(REFRESH_TOKEN_COOKIE));
      if (!credentials || !Object.keys(credentials).length || !credentials.access_token) {
        console.log('Token refresh failed, redirecting to login');
        // Store current location for redirect back after login
        sessionStorage.setItem(
          SessionStorageKeys.POST_LOGIN_REDIRECT,
          document.location.pathname ? document.location.pathname + document.location.search : null
        );
        await redirectToLogin();
        return null;
      }
      document.cookie = `${ACCESS_TOKEN_COOKIE} = ${credentials.access_token}; domain=${config.COOKIES_DOMAIN}; path=/; secure;`;
      document.cookie = `${REFRESH_TOKEN_COOKIE} = ${credentials.refresh_token}; domain=${config.COOKIES_DOMAIN}; path=/; secure;`;
      return credentials.access_token;
    } catch (error) {
      console.error('Error during token refresh:', error);
      await redirectToLogin();
      return null;
    }
  }
}

export async function getAccessTokenPayload() {
  const token = await getAccessToken();

  return jwtDecode(token);
}

export function getRefreshToken() {
  return getCookie(REFRESH_TOKEN_COOKIE);
}

const getAppSubDomain = (): string => {
  const cookiesDomainIndex: number = window.location.hostname.indexOf(config.COOKIES_DOMAIN);
  if (cookiesDomainIndex <= 0) {
    return undefined;
  }
  return window.location.hostname.slice(0, cookiesDomainIndex);
};

export const setPostLoginRedirectCookie = () => {
  document.cookie = `${POST_LOGIN_REDIRECT_COOKIE}=${getAppSubDomain()}; domain=${
    config.COOKIES_DOMAIN
  }; path=/; secure;`;
};

export const isAuthImageUrl = (imageUrl: string): boolean => {
  if (!imageUrl) {
    return null;
  }
  return imageUrl.includes('kong') || imageUrl.includes('external');
};

export async function redirectToLogin(isLogout?: boolean) {
  setPostLoginRedirectCookie();
  if (isLogout) {
    clearUserCookies();
    sessionStorage.removeItem(SessionStorageKeys.REQUESTED_OKTA_SCOPE);
  } else {
    sessionStorage.setItem(
      SessionStorageKeys.POST_LOGIN_REDIRECT,
      document.location.pathname ? document.location.pathname + document.location.search : null
    );
  }
  setTimeout(() => {
    if (process.env.REACT_APP_IS_EXTERNAL_LOGIN_ENABLED === 'true') {
      window.location.replace(config.LOGIN_URL);
      return;
    }
    window.location.replace(PAGES_BASE_PATHNAMES.Login);
  }, 0);
}
